const apiUrl = 'https://stg-ai-api.neevai.io/api/KeepAlive/ping';

export const keepAlive = async (sessionId) => {
  const url = `${apiUrl}/${sessionId}`;
  const response = await fetch(url, {
    method: "PATCH",
  });
  return await response;
}